import { render, staticRenderFns } from "./SaldoFavorModal.vue?vue&type=template&id=14325b1c"
import script from "./SaldoFavorModal.vue?vue&type=script&lang=js"
export * from "./SaldoFavorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports